import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { UpdateDomainView } from './create/updateDomain.view';

/**
 * Routeur pour la gestion des domaines
 * 
 * Ce routeur gère la navigation pour :
 * - Modification du domaine actuel (/domain)
 * 
 * Logique métier :
 * - Un seul domaine par instance (pas de liste)
 * - Accès direct à la modification du domaine connecté
 * - Gestion des paramètres multi-tenant
 * 
 * @returns Composant React du routeur des domaines
 */
export const DomainRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <UpdateDomainView />
        </Route>
      </Switch>
    </div>
  );
};
